/**
 * Enum for the native Ad Provider list which users might start with
 */
const enum NativeAdInitialProvider {
    Bing,
    AppNexus,
    Prebid,
}

export default NativeAdInitialProvider;
